import React, { useState } from 'react';
import { UserAvatarProps } from '../../../types/header.types';
import { ShowAccountMenu } from '../../../components/showaccountmenu/account-menu.component'
import { useSelector } from 'react-redux';

const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  onClick,
  className = ''
}) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const getUserFirstNameInitial = useSelector((state: any) => state.auth.user || '');
     const {
        personalData,
    } = useSelector((state: any) => state.profileSettings);
  const totalName = String(personalData.firstName).charAt(0) + (String(personalData?.lastName).charAt(0) ?? 'S') || String(getUserFirstNameInitial.firstName).charAt(0) + (String(getUserFirstNameInitial?.lastName).charAt(0) ?? 'S');

  function handleClick() {
    setIsUserMenuOpen(!isUserMenuOpen);
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if ((event.key === 'Enter' || event.key === ' ') && onClick) {
      event.preventDefault();
    }
  };

  return (
    <>
      {isUserMenuOpen && <ShowAccountMenu totalName={totalName}  setIsOpen={setIsUserMenuOpen}/>}
      <div
        className={`user-avatar`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        <div className="user-avatar__container">
          {/* {user?.avatar ? (
            <img
              src={user.avatar}
              alt={user?.name || 'User avatar'}
              className="user-avatar__image"
            />
          ) : ( */}
          <div className="user-avatar__initials">
            {totalName}
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default UserAvatar;


